"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/fourFive/fourFiveScoreViewModel',["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";

    var FourFiveScoreViewModel = function () {
        function FourFiveScoreViewModel(fourFiveScore) {
            _classCallCheck(this, FourFiveScoreViewModel);

            this.id = ko.observable('');
            this.userId = ko.observable('');
            this.score = ko.observable(0);
            this.scoredOn = ko.observable('');
            this.type = ko.observable('');
            this.description = ko.observable('');
            this.resourceId = ko.observable('');
            this.update(fourFiveScore);
        }

        _createClass(FourFiveScoreViewModel, [{
            key: "update",
            value: function update(fourFiveScore) {
                this.id(fourFiveScore.id);
                this.userId(fourFiveScore.userId);
                this.score(fourFiveScore.score);
                this.scoredOn(fourFiveScore.scoredOn);
                this.type(fourFiveScore.type);
                this.description(fourFiveScore.description);
                this.resourceId(fourFiveScore.resourceId);
            }
        }, {
            key: "clear",
            value: function clear() {
                this.id('');
                this.userId('');
                this.score(0);
                this.scoredOn('');
                this.type('');
                this.description('');
                this.resourceId('');
            }
        }]);

        return FourFiveScoreViewModel;
    }();

    return FourFiveScoreViewModel;
});
//# sourceMappingURL=fourFiveScoreViewModel.js.map;
